import { getSessionData } from '../../helpers/storeHelper';
import { useAppContext } from '../../store';
import useUserType from '../useUserType';

const useAPIHeaders = () => {
  const { userType } = useUserType();
  const {
    accessTokenData: { access_token },
    binderPayNowLoginDetails: { mppId, applicationId },
    binderPaymentDetails: {
      applicationId: applicantIdBinderPayLater,
      mppId: mppIdBinderPaylater,
    },
    memberDetails,
  } = useAppContext();

  const { memberBillingInfoRequestPayload, brokerDetails } = memberDetails;
  const { brokerId } = brokerDetails || {};

  const { productDetail, dataSource, derivedLob } =
    memberBillingInfoRequestPayload ?? {};
  const { productType } = productDetail ?? {};

  const { ACCESS_TOKEN } = getSessionData();
  const {
    isGuestUser,
    isActiveUser,
    isBinderPayNowUser,
    isBinderPayLaterUser,
    isOneTimePaymentActiveUser,
    isCA,
    isCaBinderPayLaterUser,
    isGuestGovernmentUser,
    isActiveGovernmentUser,
    isCATermedMember,
    isBrokerUser,
  } = useUserType();

  const getUserSpecificHeader = (headers: any) => {
    if (isGuestUser) {
      return {
        ...headers,
      };
    }
    if (isGuestGovernmentUser) {
      return {
        ...headers,
        USER_TYPE_CODE: userType,
      };
    }
    if (isBinderPayLaterUser || isCaBinderPayLaterUser) {
      return {
        ...headers,
        USER_TYPE_CODE: userType,
        MPP_ID: mppIdBinderPaylater,
        APPLICATION_ID: applicantIdBinderPayLater,
      };
    }
    if (isCA || isCATermedMember) {
      return {
        ...headers,
        AUTHORIZATION: `Bearer ${
          access_token !== '' ? access_token : ACCESS_TOKEN
        }`,
        USER_TYPE_CODE: userType,
      };
    }
    if (isActiveUser || isOneTimePaymentActiveUser || isActiveGovernmentUser) {
      return {
        ...headers,
        USER_TYPE_CODE: userType,
        AUTHORIZATION: `Bearer ${
          access_token !== '' ? access_token : ACCESS_TOKEN
        }`,
      };
    }
    if (isBinderPayNowUser) {
      return {
        ...headers,
        USER_TYPE_CODE: userType,
        MPP_ID: mppId,
        APPLICATION_ID: applicationId,
      };
    }
    if (isBrokerUser) {
      return {
        ...headers,
        BROKER_ID: brokerId,
        USER_TYPE_CODE: userType
      };
    }
    return { ...headers };
  };

  const getGovUserSpecificHeader = (headers: any) => {
    if (isGuestGovernmentUser) {
      return {
        ...headers,
        USER_TYPE_CODE: userType,
        LOB: derivedLob,
        PRODUCT_TYPE: productType,
        DATA_SOURCE: dataSource,
      };
    }
    if (isActiveGovernmentUser) {
      return {
        ...headers,
        USER_TYPE_CODE: userType,
        AUTHORIZATION: `Bearer ${
          access_token !== '' ? access_token : ACCESS_TOKEN
        }`,
        LOB: derivedLob,
        PRODUCT_TYPE: productType,
        DATA_SOURCE: dataSource,
      };
    }
    return { ...headers };
  };

  return { getUserSpecificHeader, getGovUserSpecificHeader };
};

export default useAPIHeaders;
